import React from 'react'
import './about.css'
import AboutImg from '../../assets/profile.png'
import Info from './Info'
import CV from '../../assets/Khaled abdulrahmann.pdf'

const About = () => {
  return (
    <div className="section about" id="about">

    <h2 className="section__title">About Me</h2>
    <span className="section__subtitle">My Introductions</span>
    <div className="about__container container grid">
        <img src={AboutImg} alt="" className="about__img" />
        <div className="about__data">
            <Info />
            <p className="about__description">
                Fullstack Developer, I create Mobile Apps , Web Pages with UI / UX and Backend, I have years of experience and many clients are happy with the projects carried out.
            </p>
            <a href={CV} className="button button--flex">Download CV    
              <i class="uil uil-file-download-alt" style={{'marginLeft':'10px'}}></i>
            </a>
           
        </div>
    </div>
</div> 
 )
}
 
export default About